import React, {useEffect, useState} from 'react'
import {makeStyles} from "@material-ui/core/styles";
import ResourceRow from "./SubComponents/ResourceRow";
import ResourceTools from './SubComponents/ResourceTools';
import CircularProgress from "@material-ui/core/CircularProgress";
import {getResourceData, sortItems} from './Helpers';
import Breadcrumb from '../Common/Breadcrumb/Breadcrumb';
import './ResourceCenter.scss';

const ResourceCenter = (props) => {
  const [state, updateState] = useState({
    loadingResources: true,
    howTos: {},
    estatePlanning: {},
    salesTools: {},
    retirementPlanning: {},
    searchResults: {},
    search: ''
  });
  const [expandedPanel, setExpandedPanel] = useState({panel1 : true, panel2: false, panel3: false});

  const css = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let debounce = null;
  useEffect(() => {
    let isSubscribed = true;
    if (debounce) {
      clearTimeout(debounce);
    }
    debounce = setTimeout(() => getData(() => isSubscribed), 1500);
    return () => {
      clearTimeout(debounce);
      isSubscribed = false;
    }
  }, [state.search]);

  const getData = (isSubscribed) => {
    if (!isSubscribed()) return;

    updateState({...state, loadingResources: true});

    getResourceData(state.search).then(resData => {
      const ht = sortItems(resData.content, "How To's", resData.content.length),
        st = sortItems(resData.content, 'Sales Tools', resData.content.length),
        ep = sortItems(resData.content, 'Estate Planning', resData.content.length),
        rp = sortItems(resData.content, 'Retirement Planning', resData.content.length);

      let sr;
      if (state.search) {
        sr = sortItems(resData.content, 'Search Results', resData.content.length);
        console.log(sr);
      }

      updateState({
        ...state, loadingResources: false,
        howTos: ht,
        estatePlanning: ep,
        retirementPlanning: rp,
        salesTools: st,
        searchResults: sr
      });
    }).catch(x => console.log(x));
  }

  return (
    <React.Fragment>
      <div className={`mb-3 py-4 resourcesBackground ${css.resourcesContainer}`}>
        <Breadcrumb breadcrumbLinks={[{ name: 'HOME', href: '/' }]} currentPage={'RESOURCE CENTER'} />
        <h2 className='mt-3'>Resource Center</h2>
      </div>
      <ResourceTools searchState={state.search} updateSearch={(v) => updateState({...state, search: v, loadingResources: true})}/>
      <div className={`${css.resourcesContainer}`}>
        {state.loadingResources && <div className={'mt-2 mb-3 d-flex justify-content-center'}><CircularProgress /></div>}
        {(!state.loadingResources && !state.search) && (
          <React.Fragment>
            <h5 className='resource-panel-title'>Resources</h5>
            <ResourceRow {...state.howTos} title='Getting to Know Covr' expanded={expandedPanel.panel1} handleChange={() => setExpandedPanel({...expandedPanel, panel1: !expandedPanel.panel1, panel2: false, panel3: false})} />
            <ResourceRow {...state.estatePlanning} title='Sales Concepts' expanded={expandedPanel.panel2} handleChange={() => setExpandedPanel({...expandedPanel, panel1: false, panel2: !expandedPanel.panel2, panel3: false})}/>
          </React.Fragment>
        )}
        {(!state.loadingResources && state.search) && <ResourceRow {...state.searchResults} />}
      </div>
    </React.Fragment>
  )
}
const useStyles = makeStyles(theme => ({
  resourcesContainer: {
    padding: '15px 30px 15px 30px'
  }
}));

export default ResourceCenter;


// WEBPACK FOOTER //
// ./src/components/Resource Center/ResourceCenter.js